import { AxiosResponse } from "axios";
import { ApiUsuarios } from "../../Apis/Usuarios";
import {
  IPagePerfilDTO,
  IPerfilAtualizarForm,
  IPerfilDTO,
  IPerfilForm,
  IPerfilGetProps,
} from "../../types/perfil";
import { removeEmpty } from "../../utils/removeEmpty";

const basePath = "/perfil";

export class Perfil {
  static async get(
    props?: IPerfilGetProps
  ): Promise<AxiosResponse<IPagePerfilDTO>> {
    let params = "";
    if (props) {
      const values = removeEmpty(props);
      params = new URLSearchParams(values).toString();
    }
    return ApiUsuarios.get(params ? `${basePath}?${params}` : basePath);
  }

  static async getById({
    id,
  }: {
    id: string;
  }): Promise<AxiosResponse<IPerfilDTO>> {
    return ApiUsuarios.get(`${basePath}/${id}`);
  }

  static async getRecursos(): Promise<AxiosResponse<string[]>> {
    return ApiUsuarios.get(`${basePath}/recursos-disponiveis`);
  }

  static async post(data: IPerfilForm): Promise<AxiosResponse<IPerfilDTO>> {
    return ApiUsuarios.post(basePath, data);
  }

  static async put(
    data: IPerfilAtualizarForm
  ): Promise<AxiosResponse<IPerfilDTO>> {
    const { uuid, ...rest } = data;
    return ApiUsuarios.put(`${basePath}/${uuid}/atualizar`, rest);
  }
}
